import { gsap } from "gsap";
    
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { TextPlugin } from "gsap/TextPlugin";



import Headroom from "headroom.js";

import Swiper from 'swiper/bundle';

// Swiper GSAP Texte animieren
function initSwiperGsapText(swiperRootEl, swiperInstance) {

    const swiperSlides = swiperInstance.slides;

    if (!swiperSlides || !swiperSlides.length) return;

    swiperSlides.forEach((swiperSlideEl) => {

        const swiperGsapTextWrappers = swiperSlideEl.querySelectorAll(".js-gsap-swiper-text");

        if (!swiperGsapTextWrappers.length) return;

        // Eine Timeline pro Slide
        const swiperSlideTimeline = gsap.timeline({
            paused: true
        });

        const swiperGsapTextElements = [];

        swiperGsapTextWrappers.forEach((textWrapperEl) => {

            const gsapTextEl = textWrapperEl.querySelector(".gsap-element");

            if (!gsapTextEl) return;

            swiperGsapTextElements.push(gsapTextEl);
        });

        if (!swiperGsapTextElements.length) return;

        // Stagger Animation
        swiperSlideTimeline.fromTo(
            swiperGsapTextElements,
            {
                yPercent: 100,
                opacity: 0,
                autoAlpha: 0,
            },
            {
                yPercent: 0,
                opacity: 1,
                autoAlpha: 1,
                duration: 0.9,
                ease: "power3.out",
                stagger: 0.3
            }
        );

        swiperSlideEl._swiperGsapTimeline = swiperSlideTimeline;
    });

    const updateSwiperGsap = () => {

        swiperInstance.slides.forEach((swiperSlideEl, index) => {

            const tl = swiperSlideEl._swiperGsapTimeline;

            if (!tl) return;

            if (index === swiperInstance.activeIndex) {
                tl.play(0); // immer von vorne sauber starten
            } else {
                tl.reverse();
            }
        });
    };

    updateSwiperGsap();

    swiperInstance.on("slideChange", updateSwiperGsap);
}


// wait until DOM is ready
document.addEventListener("DOMContentLoaded", function(event) {


   // Boostrap Tooltips
   var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
   var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
     return new understrap.Tooltip(tooltipTriggerEl)
   })

    // GSAP START
    gsap.registerPlugin(ScrollTrigger,TextPlugin);

    //Age Restriction Animation
    if (document.body.classList.contains('age-restriction-active')) {

        let ageTl = gsap.timeline();

        ageTl.to("#gilde-biermarke-animation", {
            scale: 1,        
            opacity: 0,      
            duration: 0.4   
        });

        ageTl.fromTo(".age-restriction", 
            {
                opacity: 0,
                scale: 0.5
            },  
            { 
                opacity: 1,       
                scale: 1,
                duration: 1, 
                ease: "power3.out"
            }, "-=.1");
    }

    // HEADROOM.JS
    var Header = document.querySelector('#wrapper-navbar');
    var headroom = new Headroom(Header, {
        'offset': 500,
        'tolerance': 5
    });
    headroom.init();

    //wait until images, links, fonts, stylesheets, and js is loaded
    window.addEventListener("load", function(e) {

         // HEADER SCROLL CLASS
        let scrollpos = window.scrollY
        const header = document.querySelector('#wrapper-navbar')
        const header_height = header.offsetHeight

        const add_class_on_scroll = () => header.classList.add('header-scrolled')
        const remove_class_on_scroll = () => header.classList.remove('header-scrolled')

        window.addEventListener('scroll', function() {
            scrollpos = window.scrollY;

            if (scrollpos >= header_height) {
                add_class_on_scroll()
            } else {
                remove_class_on_scroll()
            }
        })

        var myOffcanvas = document.getElementById('navbarNavOffcanvas')
        myOffcanvas.addEventListener('show.bs.offcanvas', 
        function () {
            document.body.classList.add("offcanvas-active");
        })
        var myOffcanvas = document.getElementById('navbarNavOffcanvas')
        myOffcanvas.addEventListener('hidden.bs.offcanvas', 
        function () {
            document.body.classList.remove("offcanvas-active");
        })

    
        // create
        let mm = gsap.matchMedia();

        // add a media query. When it matches, the associated function will run
        mm.add("(min-width: 991.99px)", () => {
        // this setup code only runs when viewport is at least 991.99px wide

            //Flasche Aktiv Klasse beim ersten Laden entfernen
            let flaschenAll = document.querySelectorAll(".col-flasche");

            if(flaschenAll) {
                flaschenAll.forEach((flasche) => {
                    flasche.classList.remove("col-flasche-active");
                });

            }
      
            //Flasche nach Scrollen aktiv
            let flascheActive = document.querySelector(".col-flasche:nth-child(3)");

            if(flascheActive) {
                gsap.to(flascheActive, {
                    duration: .3,
                    scrollTrigger: { 
                        trigger: flascheActive,
                        start: "top 60%",
                    },
                    onComplete: () => flascheActive.classList.add("col-flasche-active")
                });
            }

         


        });
        // add a media query. When it matches, the associated function will run
        mm.add("(max-width: 991.98px)", () => {
        // this setup code only runs when viewport is at least 991.99px wide
            
          
    
        });


   
        //GSAP Bilder animieren
        let gsapImageContainers = document.querySelectorAll('.gsap-image');

        if(gsapImageContainers) {

            gsapImageContainers.forEach((gsapImageContainer) => {

                let gsapImage = gsap.utils.toArray('img', gsapImageContainer);
    
                gsap.fromTo(gsapImageContainer, {
                    y: 100
                  },
                  {
                    y: 0,
                    duration: 1,
                    ease: 'power2.outIn'
                });
                gsap.fromTo(gsapImage, {
                    scale: 1.3,
                    opacity: 0
                  },
                  {
                    scale: 1,
                    opacity: 1,
                    duration: 1,
                    ease: 'power2.outIn',
                    scrollTrigger: { 
                        trigger: gsapImageContainer,
                        start: 'top 85%',                       
                    },
                }, "<");
    
            });

        }

      
        // GSAP Text Slide-In
        let gsapSlideContainers = document.querySelectorAll('.gsap-slide-container');

        if(gsapSlideContainers) {

            gsapSlideContainers.forEach((gsapSlideContainer, i) => {

                let gsapText = gsapSlideContainer.querySelector(".gsap-element");


                let gsapDontReverse = gsapSlideContainer.querySelector(".gsap-element-no-reverse");
                // Wenn das GSAP-Animationselement die Klasse oben hat, wird die Animation nur einmal abgespielt
                let toggleActionsValue = gsapDontReverse ? "play none none none" : "play reset resume reset";

                let tl = gsap.timeline({
                    delay: i * 0.3,
                    scrollTrigger: {
                        trigger: gsapSlideContainer,
                        start: "top 125%",
                        toggleActions: toggleActionsValue,
                        // toggleClass: "timeline-finished"
                    }
                });
                
                tl.fromTo( gsapText, { 
                        yPercent: 100,
                        opacity: 0,
                        autoAlpha: 0,
                    },
                    {
                        delay: .02,
                        yPercent: 0,
                        opacity: 1,
                        autoAlpha: 1,
                        duration: .9,
                        ease: 'power3.out',
                    }
                )
    
            });      

        }


        // GSAP Scale-In Bounce
        let gsapScaleBounceContainers = document.querySelectorAll('.gsap-scale-bounce-container');

        if (gsapScaleBounceContainers.length) {

            gsap.utils.toArray(gsapScaleBounceContainers).forEach(section => {

                const elems = section.querySelectorAll('.gsap-element');

                // Startzustand
                gsap.set(elems, {
                    opacity: 0,
                    scale: 0,
                    autoAlpha: 0
                });

                // Eine einzige Timeline
                const tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: section,
                        start: "top 85%",
                        end: "bottom top",
                        toggleActions: "play reverse play reverse",
                        invalidateOnRefresh: true
                    }
                });

                // Animation
                tl.to(elems, {
                    opacity: 1,
                    autoAlpha: 1,
                    scale: 1,
                    duration: 0.7,
                    stagger: 0.3,
                    ease: "back.out(1.4)",
                    overwrite: "auto"
                });

            });

        }

        // GSAP Scale Animation
        let gsapScaleContainers = document.querySelectorAll('.gsap-scale-container');

        if (gsapScaleContainers.length) {

            gsap.utils.toArray(gsapScaleContainers).forEach(section => {

                const elems = section.querySelectorAll('.gsap-element');

                // Startzustand
                gsap.set(elems, {
                    opacity: 0,
                    autoAlpha: 0,
                    scale: 0.5
                });

                // Eine Timeline für alles
                const tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: section,
                        start: "top bottom-=100",
                        end: "bottom top",
                        toggleActions: "play reverse play reverse",
                        invalidateOnRefresh: true,
                        // markers: true
                    }
                });

                // Enter + Reverse automatisch
                tl.to(elems, {
                    opacity: 1,
                    autoAlpha: 1,
                    scale: 1,
                    duration: 0.75,
                    stagger: 0.3,
                    ease: "power3.out",
                    overwrite: "auto"
                });

            });

        }

    
        //Flaschen Click Expand Startseite
        const flascheColumns = document.querySelectorAll('.col-flasche');

        if(flascheColumns) {

            flascheColumns.forEach((flascheColumn) => {

                const flascheImage = flascheColumn.querySelector('.flasche-image img');

                if(flascheImage) {
                    flascheImage.addEventListener('click', () => {
    
                        const hasActiveClass = flascheColumn.classList.contains('col-flasche-active');
        
                        flascheColumns.forEach((flasche) => {
                            flasche.classList.remove('col-flasche-active');
                        });
        
                        if (hasActiveClass) {
                            flascheColumn.classList.remove('col-flasche-active');
                        }
                        else {
                            flascheColumn.classList.add('col-flasche-active');
                        }
                    });       
                }
    
            });

        }


        // Bier Übersicht GSAP Animation
        let gsapRowFilterRows = document.querySelectorAll(".row-filter");
        if (gsapRowFilterRows.length) {

            gsapRowFilterRows.forEach((gsapRowFilterRow) => {

                const gsapRowFilterCols = gsapRowFilterRow.querySelectorAll(".col-filter");

                gsap.set(gsapRowFilterCols, {
                    scale: 0.1,
                    opacity: 0
                });

                gsap.to(gsapRowFilterCols, {
                    scale: 1,
                    opacity: 1,
                    duration: 0.5,
                    stagger: 0.1,
                    ease: "back.out(1.4)",

                    scrollTrigger: {
                        trigger: gsapRowFilterRow,
                        start: "top bottom-=100",
                        toggleActions: "play none none none",
                        invalidateOnRefresh: true,
                        fastScrollEnd: true,
                        preventOverlaps: true
                    }
                });

            });

        }
        

        //Flaschen Einzel-Seite START
        const beitragEinzelansicht = document.getElementById('single-wrapper');

        if(beitragEinzelansicht) {


            const toggleInfos = document.getElementById('toggle-infos');
            const toggleInfosBtns = document.querySelectorAll('.toggle-trigger-infos');

            const toggleFakten = document.getElementById('toggle-fakten');
            const toggleFaktenBtns = document.querySelectorAll('.toggle-trigger-fakten');

            const toggleGebinde = document.getElementById('toggle-gebinde');
            const toggleGebindeBtns = document.querySelectorAll('.toggle-trigger-gebinde');

            
            if (toggleInfosBtns.length) {
                toggleInfosBtns.forEach((toggleInfosBtn) => {
                    toggleInfosBtn.addEventListener('click', () => {
                        const hasActiveClass = toggleInfos.classList.contains('toggle-details-active');
    
                        if(toggleFakten) {
                            toggleFakten.classList.remove('toggle-details-active');
                        }
                        if(toggleGebinde) {
                            toggleGebinde.classList.remove('toggle-details-active');
                        }
    
                
                        if (hasActiveClass) {
                            toggleInfos.classList.remove('toggle-details-active');
                        }
                        else {
                            toggleInfos.classList.add('toggle-details-active');
                        }
    
                    });
                });
            }

            if(toggleFaktenBtns.length) {
                toggleFaktenBtns.forEach((toggleFaktenBtn) => {
                    toggleFaktenBtn.addEventListener('click', () => {
                        const hasActiveClass = toggleFakten.classList.contains('toggle-details-active');

                        if(toggleInfos) {
                            toggleInfos.classList.remove('toggle-details-active');
                        }
                        if(toggleGebinde) {
                            toggleGebinde.classList.remove('toggle-details-active');
                        }

                        
                        if (hasActiveClass) {
                            toggleFakten.classList.remove('toggle-details-active');
                        }
                        else {
                            toggleFakten.classList.add('toggle-details-active');
                        }

                    });
                });
            }

            if(toggleGebindeBtns.length) {
                toggleGebindeBtns.forEach((toggleGebindeBtn) => {
                    toggleGebindeBtn.addEventListener('click', () => {
                        const hasActiveClass = toggleGebinde.classList.contains('toggle-details-active');

                        if(toggleInfos) {
                            toggleInfos.classList.remove('toggle-details-active');
                        }
                        if(toggleFakten) {
                            toggleFakten.classList.remove('toggle-details-active');
                        }


                        if (hasActiveClass) {
                            toggleGebinde.classList.remove('toggle-details-active');
                        }
                        else {
                            toggleGebinde.classList.add('toggle-details-active');
                        }

                    });
                });
            }


            const beitragImages = document.querySelectorAll(".single-flasche .bier-image img");
            const beitragImageStoerer = document.querySelector(".single-flasche .bier-stoerer");
            const beitragTrigger = document.querySelectorAll(".toggle-trigger");

            if(beitragImages) {
                beitragImages.forEach((beitragImage) => {

                    gsap.set(beitragImage, {
                        xPercent: -250,
                        opacity: 0
                    });
        
                    if(beitragImageStoerer) {
                        gsap.set(beitragImageStoerer, {
                            scale: 0,
                            opacity: 0
                        });
                    }
                          
                    gsap.set(beitragTrigger, {
                        scale: 0,
                        opacity: 0
                    });
            
            
                    let tlBeitrag = gsap.timeline({
                    });       
            
                    tlBeitrag.to(beitragImage, { 
                        duration: .8,
                        xPercent: 0,
                        opacity: 1,
                        ease: "back.out(1.7)"
                    });
        
                    if(beitragImageStoerer) {
                        tlBeitrag.to(beitragImageStoerer, { 
                            scale: 1,
                            opacity: 1,
                            duration: .4,
                            ease: "back.out(1.7)"
                        });
                    }
            
                    tlBeitrag.to(beitragTrigger, { 
                        scale: 1,
                        opacity: 1,
                        delay: .3,
                        stagger: .2,
                        duration: .4,
                        ease: "back.out(1.7)"
                    }, "-=.4");
            
            
                    tlBeitrag.to(beitragTrigger, { 
                        scale: .8,
                        ease: "linear",
                        duration: 1,
                        repeat: -1,
                        yoyo: true
                    }, "+=.2");


                });
            }

        } 
        //Flaschen Einzel-Seite END
     
        const btnDetailTriggers = document.querySelectorAll('.toggle-trigger');
        
        if(btnDetailTriggers) {

            btnDetailTriggers.forEach((btnDetailTrigger) => {

                btnDetailTrigger.addEventListener('click', () => {

                    const hasActiveClass = btnDetailTrigger.classList.contains('toggle-trigger-active');
    
                    btnDetailTriggers.forEach((button) => {
                        button.classList.remove('toggle-trigger-active');
                    });
    
                    if (hasActiveClass) {
                        btnDetailTrigger.classList.remove('toggle-trigger-active');
                    }
                    else {
                        btnDetailTrigger.classList.add('toggle-trigger-active');
                    }
                  

                });

            });
        }






        // TIMELINE Historie
        const timelineContainer = document.querySelector(".timeline-container");

        if(timelineContainer) {

            ScrollTrigger.create({
                trigger: ".timeline-border-circle",
                start: "top 35%",
                endTrigger: timelineContainer, // outside timeline
                end: "bottom-=200px 35%", //The end point must be the bottom point of the timeline
                pin: true,
                pinSpacing: false,
                scrub: 1
            });
            gsap.utils.toArray(".timeline-section").forEach((section) => {
                const tls = gsap.timeline({
                    scrollTrigger: {
                        trigger: section,
                        start: "top 35%",
                       
                        end: "+=100%"
                    }
                });
            }); 

        }

        // TIMELINE Historie Texte
        let timelineContents = document.querySelectorAll('.timeline-section');

        timelineContents.forEach((timelineContent) => {

            let timelineHeadline = timelineContent.querySelector(".timeline-content-headline");
            let timelineHeadlineProzess = timelineContent.querySelector(".prozess-headline");
            let timelineText = timelineContent.querySelector(".timeline-content-text");
            let timelineImage = timelineContent.querySelector(".timeline-image");

            let opacityValue = timelineHeadlineProzess ? 1 : 1;
           
            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: timelineContent,
                    start: "top 45%",
                    end: "+=100%",
                    toggleActions: "play reverse play reverse"
                }
            });

            gsap.set(timelineHeadline, {
                opacity: 0,
                scale: 0
            });
            gsap.set(timelineText, {
                opacity: 0,
                scale: 0,
            });
            gsap.set(timelineImage, {
                opacity: 0,
                scale: 0.4
            });

            tl.to(timelineImage, {
                opacity: 1,
                scale: 1,
                duration: .7,
                ease: "back.out(1.4)"
            });
            tl.to(timelineHeadline, {
                opacity: opacityValue,
                scale: 1,
                duration: .4,
                ease: "back.out(1.7)"
            }, "-=.2");
            tl.to(timelineText, {
                opacity: 1,
                scale: 1,
                duration: .3,
                stagger: .3,
                ease: 'power3.out'
            }, "-=.2");

        });      
        
        // Brauprozess
        const brauProzessContainer = document.querySelector(".brauprozess-container");
        const progressDiv = document.getElementById('timeline-number');
        const bierSVGContainer = document.getElementById('bier-svg-wrapper');
        const bierSVG1 = document.getElementById('icon-bier-l');
        const bierSVG2 = document.getElementById('icon-bier-r');
        const bierSVG3 = document.querySelectorAll('line');
        
        if (brauProzessContainer) {
            // Initiale Positionen und Transformationen setzen
          

            gsap.set(bierSVG1, {
                x: -80,
                rotate: 10,
                transformOrigin: "bottom center",
                opacity: 0
            });
        
            gsap.set(bierSVG2, {
                x: 80,
                rotate: -10,
                transformOrigin: "bottom center",
                opacity: 0
            });

            gsap.set(bierSVG3, {
                strokeDashoffset: 35,
            });
        
            // ScrollTrigger erstellen
            ScrollTrigger.create({
                trigger: brauProzessContainer,
                start: "top 15%",
                end: "94% 27%",
                onUpdate({ progress }) {
                    if (progress >= 1) {
                        // Wenn der Fortschritt 100% erreicht, Animationen abspielen
                        gsap.to(progressDiv, {
                            duration: 0,
                            text: "Prost!",
                            ease: "none",
                        });
        
                        gsap.to(progressDiv, {
                            duration: .3,
                            scale: 1.2,
                            ease: "back.out(1.7)",
                        });

                        gsap.to(bierSVGContainer, {
                            height: "auto",
                            duration: 0
                        });
                        
                        gsap.to(bierSVG1, {duration: .7, ease: "back.out(1.4)", x: 0, rotate: 0, opacity: 1});
                        gsap.to(bierSVG2, {duration: .7, ease: "back.out(1.4)", x: 0, rotate: 0, opacity: 1});
                        gsap.to(bierSVG3, {duration: .7, ease: "none", strokeDashoffset: 0});

                    } else {
                        // Wenn der Fortschritt unter 100% fällt, Animationen zurücksetzen
                        progressDiv.innerHTML = `${(progress * 100).toFixed()}%`;
        
                        // Zurück zur ursprünglichen Position und Drehung der SVGs
                        gsap.to(progressDiv, {
                            duration: .3,
                            scale: 1,
                            ease: "back.out(1.7)",
                        });
                        gsap.to(bierSVG1, { duration: 0.2, ease: "back.out(1.4)", x: -80, rotate: 10, opacity: 0 });
                        gsap.to(bierSVG2, { duration: 0.2, ease: "back.out(1.4)", x: 80, rotate: -10, opacity: 0 });
        
                        // Zurücksetzen der strokeDashoffset für alle Linien
                        gsap.to(bierSVG3, { duration: 0, ease: "none", strokeDashoffset: 35 }); // Falls 100 die ursprüngliche Offset-Länge ist

                        gsap.to(bierSVGContainer, {
                            height: "0",
                            duration: 0
                        });
                    }
                }
            });
        }

        //SWIPER Allgemein
        const swiperElements = document.querySelectorAll(
            '.swiper:not(#swiper-biersorten):not(.gastro-swiper)'
        );

        if (swiperElements.length) {
            swiperElements.forEach((swiperEl) => {
                // Prüfen, ob dieser Swiper bereits initialisiert wurde (verhindert Doppel-Init)
                if (swiperEl.classList.contains('swiper-initialized')) return;

                const isFeldiEvent = swiperEl.classList.contains('feldi-event-swiper');
                
                // Sicherstellen, dass Pagination/Nav überhaupt da sind, bevor man sie übergibt
                const paginationEl = swiperEl.querySelector('.swiper-pagination');
                const nextEl = swiperEl.querySelector('.swiper-button-next');
                const prevEl = swiperEl.querySelector('.swiper-button-prev');

                const swiperInstance = new Swiper(swiperEl, {
                    loop: true,
                    autoHeight: true,
                    spaceBetween: isFeldiEvent ? 40 : 0,
                    pagination: paginationEl ? {
                        el: paginationEl,
                        clickable: true,
                    } : false,
                    navigation: (nextEl && prevEl) ? {
                        nextEl: nextEl,
                        prevEl: prevEl,
                    } : false,
                });

                // GSAP Texte animieren
                if (swiperEl.classList.contains("js-gsap-swiper")) {
                    // Funktion nur aufrufen, wenn sie auch definiert ist
                    if (typeof initSwiperGsapText === "function") {
                        initSwiperGsapText(swiperEl, swiperInstance);
                    }
                }
            });
        }
  
        
   
        //SWIPER Biersorten Startseite
        var init = false;
        var swiper;

        function swiperCard() {
            if (document.querySelector('#swiper-biersorten')) {
                if (window.innerWidth <= 1200) {
                    if (!init) {
                        init = true;
                        swiper = new Swiper("#swiper-biersorten", {
                            direction: "horizontal",
                            slidesPerView: 1.5,
                            grabCursor: true,
                            centeredSlides: true,
                            spaceBetween: 40,
                            pagination: {
                                el: ".swiper-pagination",
                                type: "fraction",
                            },
                            breakpoints: {                            
                                767: {
                                slidesPerView: 1.5,
                                spaceBetween: 40,
                                },
                                1199: {
                                    slidesPerView: 1.5,
                                    spaceBetween: 60,
                                }
                            }
                        
                        });
                        
                    }
                } else if (init) {
                    swiper.destroy();
                    init = false;
                }
            }         
        }
        swiperCard();
        window.addEventListener("resize", swiperCard);



        // Sponsoren sortieren START
        function initSponsorModule(options) {
            const sponsorContainer = document.querySelector(options.containerSelector);
            const loadMoreButton = document.getElementById(options.loadMoreButtonId);
            const dropdownToggle = document.querySelector('#dropdown-sponsoren-sortby .dropdown-toggle');
            
            // Das Elternelement (li) des Zurücksetzen-Buttons finden
            const resetLink = document.querySelector('.dropdown-item[data-sort="reset"]');
            const resetItem = resetLink ? resetLink.parentElement : null;

            if (!sponsorContainer) return;

            let sponsorItems = [];
            let originalSponsorItems = []; // Speicher für die Initial-Reihenfolge
            let visibleSponsorCount = 0;
            const itemsPerBatch = options.itemsPerBatch || 6;

            function collectSponsorItems() {
                sponsorItems = Array.from(
                    sponsorContainer.querySelectorAll(".sponsor-row")
                );
                // Kopie der ursprünglichen WP-Reihenfolge (menu_order) speichern
                originalSponsorItems = [...sponsorItems];
            }

            function hideAllSponsors() {
                sponsorItems.forEach(item => {
                    item.style.display = "none";
                    item.style.opacity = 0;
                });
                visibleSponsorCount = 0;
            }

            function animateItems(items) {
                if (typeof gsap === "undefined") return;
                gsap.fromTo(items,
                    { opacity: 0, y: 30 },
                    { opacity: 1, y: 0, duration: 0.5, stagger: 0.1, ease: "power2.out" }
                );
            }

            function showNextSponsors() {
                const nextBatch = sponsorItems.slice(
                    visibleSponsorCount,
                    visibleSponsorCount + itemsPerBatch
                );

                nextBatch.forEach(item => {
                    item.style.display = "flex";
                });

                animateItems(nextBatch);
                visibleSponsorCount += nextBatch.length;
                updateLoadMoreVisibility();
            }

            function showSponsorsUpTo(count) {
                const itemsToShow = sponsorItems.slice(0, count);
                itemsToShow.forEach(item => {
                    item.style.display = "flex";
                });
                animateItems(itemsToShow);
                visibleSponsorCount = itemsToShow.length;
                updateLoadMoreVisibility();
            }

            function updateLoadMoreVisibility() {
                if (!loadMoreButton) return;
                loadMoreButton.style.display = (visibleSponsorCount >= sponsorItems.length) ? "none" : "inline-block";
            }

            function sortSponsorItems(direction = "asc") {
                const currentlyVisibleCount = visibleSponsorCount;

                if (direction === "reset") {
                    sponsorItems = [...originalSponsorItems];
                } else {
                    sponsorItems.sort((a, b) => {
                        const textA = a.querySelector(".sponsor-headline").innerText.trim().toLowerCase();
                        const textB = b.querySelector(".sponsor-headline").innerText.trim().toLowerCase();

                        return direction === "desc"
                            ? textB.localeCompare(textA, 'de')
                            : textA.localeCompare(textB, 'de');
                    });
                }

                // DOM neu ordnen (vor dem Load More Button Wrapper einfügen)
                const loadMoreWrapper = loadMoreButton.parentElement;
                sponsorItems.forEach(item => {
                    sponsorContainer.insertBefore(item, loadMoreWrapper);
                });

                hideAllSponsors();
                showSponsorsUpTo(currentlyVisibleCount);
            }

            function bindEvents() {
                if (loadMoreButton) {
                    loadMoreButton.addEventListener("click", showNextSponsors);
                }

                document.querySelectorAll("#dropdown-sponsoren-sortby .dropdown-item").forEach(item => {
                    item.addEventListener("click", function (e) {
                        e.preventDefault();
                        
                        const sortDirection = this.dataset.sort || "asc";

                        // 1. Button-Text und Sichtbarkeit der Reset-Option steuern
                        if (dropdownToggle) {
                            if (sortDirection === "reset") {
                                dropdownToggle.innerText = "Sortieren";
                                if (resetItem) resetItem.style.display = 'none'; // Reset verstecken
                            } else {
                                dropdownToggle.innerText = this.innerText;
                                if (resetItem) resetItem.style.display = 'block'; // Reset anzeigen
                            }
                        }

                        // 2. Sortierung auslösen
                        sortSponsorItems(sortDirection);
                    });
                });
            }

            function init() {
                collectSponsorItems();
                hideAllSponsors();
                showNextSponsors();
                
                // Zu Beginn die Reset-Option im Dropdown verstecken
                if (resetItem) {
                    resetItem.style.display = 'none';
                }
                
                bindEvents();
            }

            init();
        }

        // Initialisierung
        initSponsorModule({
            containerSelector: ".sponsor-container",
            loadMoreButtonId: "feldi-sponsoren-loadmore",
            itemsPerBatch: 6
        });
        // Sponsoren sortieren END


        // Events sortieren, Toggle, etc. START
        function initFeldiEvents(options) {
            const container = document.querySelector(options.containerSelector);
            const loadMoreWrapper = document.querySelector(options.loadMoreWrapperSelector);
            const loadMoreBtn = loadMoreWrapper?.querySelector("button");

            if (!container) return;

            let allItems = [];
            let filteredItems = [];
            let visibleCount = 0;

            const itemsPerBatch = options.itemsPerBatch || 5;
            let activeMonth = "";
            let sortMode = "date";

            // sammeln
            function collectItems() {
                allItems = Array.from(container.querySelectorAll(".feldi-event-item"));
            }

            // NEU: Diese Funktion bringt die HTML-Elemente in die richtige Reihenfolge
            function renderDOMOrder() {
                filteredItems.forEach(item => {
                    container.appendChild(item); // appendChild verschiebt existierende Elemente an das Ende
                });
            }

            // filtern + sortieren
            function buildFilteredList() {
                filteredItems = allItems.filter(item => {
                    if (!activeMonth) return true;
                    return item.dataset.month === activeMonth;
                });

                filteredItems.sort((a, b) => {
                    if (sortMode === "az") {
                        return a.dataset.title.localeCompare(b.dataset.title, 'de');
                    }
                    return a.dataset.date.localeCompare(b.dataset.date);
                });

                // WICHTIG: Nach dem Sortieren die DOM-Reihenfolge anpassen
                renderDOMOrder();
            }

            function updateDropdownButton(dropdownItem) {
                const dropdown = dropdownItem.closest(".dropdown");
                const button = dropdown.querySelector(".dropdown-toggle");

                if (!button) return;

                button.textContent = dropdownItem.textContent;
            }            

            function hideAll() {
                allItems.forEach(item => {
                    item.style.display = "none";
                    item.style.opacity = 0;
                });
                visibleCount = 0;
            }

            function animate(items) {
                if (typeof gsap === "undefined" || items.length === 0) return;
                gsap.fromTo(items,
                    { opacity: 0, y: 30 },
                    { opacity: 1, y: 0, duration: 0.5, stagger: 0.1, overwrite: true }
                );
            }

            function showNext() {
                const next = filteredItems.slice(visibleCount, visibleCount + itemsPerBatch);
                next.forEach(item => { item.style.display = "block"; });
                animate(next);
                visibleCount += next.length;
                updateLoadMore();
            }

            function showUpTo(count) {
                const itemsToShow = filteredItems.slice(0, count);
                itemsToShow.forEach(item => { 
                    item.style.display = "block"; 
                    item.style.opacity = 1; 
                    item.style.transform = "translate(0,0)"; // Reset GSAP state
                });
                visibleCount = itemsToShow.length;
                updateLoadMore();
            }

            function updateLoadMore() {
                if (!loadMoreWrapper) return;
                if (visibleCount >= filteredItems.length) {
                    if (typeof gsap !== "undefined") {
                        gsap.to(loadMoreWrapper, { opacity: 0, duration: 0.3, onComplete: () => loadMoreWrapper.style.display = "none" });
                    } else {
                        loadMoreWrapper.style.display = "none";
                    }
                } else {
                    loadMoreWrapper.style.display = "block";
                    if (typeof gsap !== "undefined") gsap.set(loadMoreWrapper, { opacity: 1 });
                }
            }

            function rebuild() {
                hideAll();
                buildFilteredList();
                showNext();
            }

            function applySort() {
                const currentCount = visibleCount;
                hideAll();
                buildFilteredList();
                showUpTo(currentCount);
            }

            // Logik für Highlight-Ansteuerung
            function scrollToEvent(eventId) {
                const targetItem = allItems.find(item => item.dataset.id === eventId);
                if (!targetItem) return;

                allItems.forEach(item => item.classList.remove("feldi-event-is-focused"));

                if (activeMonth && targetItem.dataset.month !== activeMonth) {
                    activeMonth = "";
                    rebuild(); 
                }

                const indexInFiltered = filteredItems.indexOf(targetItem);
                if (indexInFiltered >= visibleCount) {
                    showUpTo(indexInFiltered + 1);
                }

                targetItem.classList.add("feldi-event-is-focused");

                setTimeout(() => {
                    targetItem.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    const toggleBtn = targetItem.querySelector(".feldi-event-toggle");
                    const text = targetItem.querySelector(".feldi-event-text");
                    if (toggleBtn && text && !text.classList.contains("feldi-event-is-open")) {
                        toggleBtn.click();
                    }
                }, 100);
            }

            function bindEvents() {
                loadMoreBtn?.addEventListener("click", showNext);

                document.querySelectorAll(".dropdown-item[data-sort]").forEach(el => {
                    el.addEventListener("click", function(e) {
                        e.preventDefault();

                        sortMode = this.dataset.sort;
                        updateDropdownButton(this); 

                        applySort();
                    });
                });

                document.querySelectorAll(".dropdown-item[data-month]").forEach(el => {
                    el.addEventListener("click", function(e) {
                        e.preventDefault();

                        activeMonth = this.dataset.month;
                        updateDropdownButton(this);   

                        rebuild();
                    });
                });

                document.querySelectorAll(".feldi-event-highlight-trigger").forEach(trigger => {
                    trigger.addEventListener("click", function() {
                        const id = this.dataset.id;
                        scrollToEvent(id);
                    });
                });

                const currentLang = document.documentElement.lang.startsWith('en') ? 'en' : 'de';

                container.addEventListener("click", function(e) {
                    const button = e.target.closest(".feldi-event-toggle");
                    if (!button) return;

                    const wrapper = button.closest(".feldi-event-infos-inner");
                    const text = wrapper.querySelector(".feldi-event-text");
                    if (!text) return;

                    e.stopPropagation();
                    const isOpen = text.classList.contains("feldi-event-is-open");

                    if (!isOpen) {
                        text.classList.add("feldi-event-is-open");
                        button.classList.add("feldi-event-toggle-active");
                        
                        button.textContent = currentLang === 'en'
                            ? 'Close'
                            : 'Schließen';
 
                        gsap.to(text, { height: "auto", opacity: 1, duration: 0.5, ease: "power2.inOut" });

                    } else {
                        text.classList.remove("feldi-event-is-open");
                        button.classList.remove("feldi-event-toggle-active");

                        button.textContent = currentLang === 'en'
                            ? 'Read more'
                            : 'Mehr Details';

                        gsap.to(text, { height: 0, opacity: 0, duration: 0.4, ease: "power2.inOut" });

                    }
                });
            }

            function init() {
                collectItems();
                buildFilteredList();
                hideAll();
                showNext();
                bindEvents();
            }

            init();
        }

        // INIT
        initFeldiEvents({
            containerSelector: ".feldi-events-container",
            loadMoreWrapperSelector: ".feldi-events-loadmore",
            itemsPerBatch: 5
        });
       // Events sortieren, Toggle, etc. END





        
       
        // Scroll-Back-To-Top
        const scrollTopBtn = document.querySelector('.js-scroll-top');
        if (scrollTopBtn) {
            scrollTopBtn.onclick = () => {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }

            const progressPath = document.querySelector('.scroll-top path');
            const pathLength = progressPath.getTotalLength();
            progressPath.style.transition = progressPath.style.WebkitTransition = 'none';
            progressPath.style.strokeDasharray = `${pathLength} ${pathLength}`;
            progressPath.style.strokeDashoffset = pathLength;
            progressPath.getBoundingClientRect();
            progressPath.style.transition = progressPath.style.WebkitTransition = 'stroke-dashoffset 10ms linear';
            const updateProgress = function() {
                const scroll = window.scrollY || window.scrollTopBtn || document.documentElement.scrollTopBtn;

                const docHeight = Math.max(
                    document.body.scrollHeight, document.documentElement.scrollHeight,
                    document.body.offsetHeight, document.documentElement.offsetHeight,
                    document.body.clientHeight, document.documentElement.clientHeight
                );

                const windowHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

                const height = docHeight - windowHeight;
                var progress = pathLength - (scroll * pathLength / height);
                progressPath.style.strokeDashoffset = progress;
            }

            updateProgress();
            const offset = 100;

            window.addEventListener('scroll', function(event) {
                updateProgress();

                //Scroll back to top
                const scrollPos = window.scrollY || window.scrollTopBtn || document.getElementsByTagName('html')[0].scrollTopBtn;
                scrollPos > offset ? scrollTopBtn.classList.add('is-active') : scrollTopBtn.classList.remove('is-active');

            }, false);
        }
      
   

    }, false);

});